export const pluginId = 'cancellation-fee';
